/*=========================================================================================
  File Name: moduleRegions.js
  Description: Regions Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./moduleRegionsState.js"
import mutations from "./moduleRegionsMutations.js"
import actions from "./moduleRegionsActions.js"
import getters from "./moduleRegionsGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

